import {
    useCallback,
} from 'react'

import {
    useMutation,
} from '@tanstack/react-query'

import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import requests from 'app/requests/Quote/Quote.requests'

export default ({
    id, onSuccess,
}: {
    id: number,
    onSuccess: (...args: any[]) => void
}) => {
    const token = useJWTToken()

    const {
        onSuccess: onSuccessAssigning,
        onError,
    } = useHandleStatusRequest({
        title: 'Quote was successfully assigned to Contract Basis',
        id: 'QuoteAssignedToContractBasis',
        onSuccess,
    })

    const {
        mutate: assignToContractBasis,
    } = useMutation({
        mutationFn: (quoteId: number) => {
            return simpleApi({
                ...requests.assignToContractBasis({
                    id: quoteId,
                }),
                token,
            })
        },
        onError,
        onSuccess: onSuccessAssigning,
    })

    return useCallback(() => {
        assignToContractBasis(id)
    }, [
        assignToContractBasis,
        id,
    ])
}
